var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-board-audit" }, [
    _c(
      "div",
      { staticClass: "standard-size-16 color-gray-10" },
      [
        _c("div", { staticClass: "font-bolder" }, [
          _vm._v(_vm._s(_vm.$t("pc_biz_bbs_lbl_authorInfo" /**作者信息 */))),
        ]),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_name" /** 姓名 */)) + "："
                  ),
                ]),
                _vm.detail.anonymous === 1
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_bbs_lbl_anonymous" /**匿名 */))
                      ),
                    ])
                  : _c(
                      "yxtf-tooltip",
                      { attrs: { "open-filter": true, placement: "top" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c("yxtbiz-user-name", {
                              attrs: { name: _vm.detail.fullName },
                            }),
                            _c("span", [
                              _vm._v(_vm._s("（" + _vm.detail.userName + "）")),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "yxtbiz-board-audit_ellipsis" },
                          [
                            _c("yxtbiz-user-name", {
                              attrs: { name: _vm.detail.fullName || "" },
                            }),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.detail.userName,
                                    expression: "detail.userName",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  _vm._s("（" + _vm.detail.userName + "）")
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
              ],
              1
            ),
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_dept" /**  部门 */)) + "："
                  ),
                ]),
                !_vm.detail.anonymous
                  ? _c(
                      "yxtf-tooltip",
                      { attrs: { placement: "top", "open-filter": true } },
                      [
                        _c("yxtbiz-dept-name", {
                          attrs: { slot: "content", name: _vm.detail.deptName },
                          slot: "content",
                        }),
                        _c("yxtbiz-dept-name", {
                          staticClass: "yxtbiz-board-audit_ellipsis",
                          attrs: { name: _vm.detail.deptName || "--" },
                        }),
                      ],
                      1
                    )
                  : _c("span", [_vm._v("--")]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_possion" /**岗位 */)) + "："
                  ),
                ]),
                !_vm.detail.anonymous
                  ? _c(
                      "yxtf-tooltip",
                      { attrs: { "open-filter": true, placement: "top" } },
                      [
                        _c("yxtbiz-position-name", {
                          attrs: {
                            slot: "content",
                            name: _vm.detail.positionName,
                          },
                          slot: "content",
                        }),
                        _c("yxtbiz-position-name", {
                          staticClass: "yxtbiz-board-audit_ellipsis",
                          attrs: { name: _vm.detail.positionName || "--" },
                        }),
                      ],
                      1
                    )
                  : _c("span", [_vm._v("--")]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "yxtf-row",
          { staticClass: "font-normal font-size-14", attrs: { type: "flex" } },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 16 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_content" /**内容 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  {
                    attrs: {
                      "open-filter": true,
                      content: _vm.detail.title,
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "yxtbiz-board-audit_ellipsis" }, [
                      _vm._v(_vm._s(_vm.detail.title || "--")),
                    ]),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "ml8 hand yxtbiz-board-color-detail",
                    on: { click: _vm.goDetail },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_bbs_lbl_viewDetail" /**查看详情 */))
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }